import { Visitable } from './Visitable';
import { Visitor } from './Visitor';
import Event, { EventProps } from './Event';

export interface CalendarProps {
    events: Array<EventProps>;
}

export default class Calendar implements Visitable {
    private _events: CalendarProps;
    private _eventsObjects: Array<Event>;
    // tabella <anno><mese><giorno><ora>
    private _table: any;

    constructor(props: CalendarProps) {
        this._events = props;
        // Inizializzazione degli oggetti
        this._eventsObjects = new Array<Event>();
        this._table = {};

        let evt: Event;

        this._events.events.forEach((event: EventProps, index) => {
            evt = new Event(event);
            this.insertInTable(evt);
            this._eventsObjects.push(evt);
        });

    }

    get events(): Array<Event> {
        return this._eventsObjects;
    }

    get eventsTable(): any {
        return this._table;
    }

    accept(visitor: Visitor): void {
        visitor.visitCalendar(this);
    }

    private insertInTable(event: Event) {
        let date = event.testDate;
        let year = date.year();
        const month = date.month() + 1;
        const day = date.date();
        const time = date.format('HH:mm');

        let table = this._table;

        if (!table[year]) {
            table[year] = {length: 0};
        }

        table[year].length += 1;

        if (!table[year][month]) {
            table[year][month] = {length: 0};
        }

        table[year][month].length += 1;

        if (!table[year][month][day]) {
            table[year][month][day] = {length: 0};
        }
        table[year][month][day].length += 1;

        if (!table[year][month][day][time]) {
            table[year][month][day][time] = [];
        }
        table[year][month][day][time].push(event);
    }
}
